import DataTable, {TableAction, TableColumn} from '../../../../shared/components/DataTable'
import {IStopSellModel} from './StopSellModel'

type Props = {
  data: IStopSellModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onEdit?: (stopSell: IStopSellModel) => void
  onDelete?: (stopSell: IStopSellModel) => void
  loading?: boolean
}

export const StopSellTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  loading = false,
}) => {
  const stopSellColumns: TableColumn<IStopSellModel>[] = [
    {
      key: 'reservationSource',
      label: 'Rezervasyon Kaynağı',
      className: 'fw-semibold',
    },
    {key: 'vehicleGroups', label: 'Araç Grubu'},
    {key: 'branches', label: 'Şube'},
    {key: 'startDate', label: 'Başlangıç Tarihi'},
    {key: 'endDate', label: 'Bitiş Tarihi'},
    {key: 'minimumDays', label: 'Minimum Gün'},
  ]

  const stopSellActions: TableAction<IStopSellModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: (stopSell) => onEdit?.(stopSell),
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: (stopSell) => onDelete?.(stopSell),
    },
  ]

  return (
    <DataTable
      data={data}
      columns={stopSellColumns}
      actions={stopSellActions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      loading={loading}
      emptyMessage='Henüz Stop Sell bulunamadı'
    />
  )
}
